module.exports = __webpack_public_path__ + "img/headpic_male.1fe24aa4.png";